import React from "react";

import { RootState } from "../../../redux/store/store";
import { useSelector } from "react-redux";
import SettingsProfileCard from "../../molecules/SettingsProfileCard/SettingsProfileCard";
import SettingsSubscriptionCard from "../../molecules/SettingsSubscriptionCard/SettingsSubscriptionCard";
import SettingsCard from "../../molecules/SettingsCard/SettingsCard";
import { useTranslation } from "react-i18next";

interface SettingsPageProps {
  onLogout: (deleteUserData?: boolean) => void;
}

const SettingsPage = (props: SettingsPageProps) => {
  const { onLogout } = props;

  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.settings.user);

  return (
    <div className="dui-settings-page">
      <h1 className="dui-settings-page-title">{t("settings")}</h1>
      <div className="dui-settings-page-content">
        <div className="dui-settings-page-content-2col">
          <SettingsProfileCard onLogout={onLogout} user={user} />
          <SettingsCard />
        </div>
        <div className="dui-settings-page-content-full">
          <SettingsSubscriptionCard subscription={user?.subscription ?? ""} />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
